import React, { Component } from 'react';
import './View3D.css';
import * as THREE from 'three';
import { ColladaLoader } from "three/examples/jsm/loaders/ColladaLoader";

export class View3D extends Component {

    constructor(props) {
        super(props);

        this.handleFovChange = this.handleFovChange.bind(this);
    }

    async componentDidMount() {
        const width = this.mount.clientWidth;
        const height = this.mount.clientHeight;

        // scene
        this.scene = new THREE.Scene();

        // load model
        const loader = new ColladaLoader();
        const asset = await loader.loadAsync('collada/abb_irb52_7_120.dae', event => {
            console.log(`${event.loaded}${ event.lengthComputable ? ' / '+ event.total: ''}`)
        });

        this.machine = asset.scene;

        // color each component
        this.machine.traverse(child => {
            if(child.isMesh) {
                // model does not have normals
                child.material.color = new THREE.Color('white');
                child.material.flatShading = true;
            }
        });

        // set scale
        this.machine.scale.x = this.machine.scale.y = this.machine.scale.z = 10.0;
        this.machine.updateMatrix();

        // camera
        this.camera = new THREE.PerspectiveCamera(
            75,                     // field of view
            width / height,         // aspect ratio
            .1,                     // near plane
            1000                    // far plane
        );

        const angle = 90;
        this.camera.position.x = Math.cos(angle * Math.PI / 180) * 15;
        this.camera.position.y = 15;
        this.camera.position.z = Math.sin(angle * Math.PI / 180) * 15;
        this.camera.lookAt(0, 5, 0);

        this.scene.add(this.machine);

        // lights
        const light = new THREE.HemisphereLight(0xffffff, 0x888888)
        this.scene.add(light)

        // renderer
        this.renderer = new THREE.WebGL1Renderer({ antialias: true });
        this.renderer.setClearColor('#000000');
        this.renderer.setSize(width, height);
        this.mount.appendChild(this.renderer.domElement);

        // action!
        this.start();
    }

    componentWillUnmount() {
        this.stop()
        this.mount.removeChild(this.renderer.domElement);
    }

    start = () => {
        if (!this.frameId) {
            this.frameId = requestAnimationFrame(this.animate);
        }
    }

    stop = () => {
        cancelAnimationFrame(this.frameId)
    }

    animate = () => {
        this.machine.rotation.z += .01;

        this.renderScene();
        this.frameId = requestAnimationFrame(this.animate);
    }

    renderScene = () => {
        this.renderer.render(this.scene, this.camera);
    }

    render() {
        return (
            <div className="View3D"
                style={{ width: '400px', height: '400px' }}
                ref={ mount => this.mount = mount }
            >
                <label>Field of View
                    <input type="range" min="25" max="75" onChange={this.handleFovChange}/>
                </label>
            </div>
        )
    }

    handleFovChange(event) {
        this.camera.fov = 100 - event.target.value;
        this.camera.updateProjectionMatrix();
    }
}
